import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import {
  EmployeeMyTrainingsIndexPageDocument,
  MyTrainingsSessionFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { MyTrainingCardsView } from 'modules/trainings/components/MyTrainings/MyTrainingsDatatable/CardsViewDataCollection'

import { CompletedTrainings } from './CompletedTrainings'
import { NextSessionRow } from './NextSessionRow'

const findNearestActiveTrainingSession = (
  sessions: MyTrainingsSessionFragment[] | undefined
): MyTrainingsSessionFragment | undefined => {
  if (!sessions || sessions.length === 0) {
    return undefined
  }

  const now = new Date()

  return sessions
    .filter((session) => {
      const sessionStartDate = session.startsAt ? new Date(session.startsAt) : null
      return session?.training?.status === 'active' && sessionStartDate && sessionStartDate > now
    })
    .sort((a, b) => {
      //sort in ascending order of date, from the earliest date to the latest
      const firstDate = a?.startsAt ? new Date(a?.startsAt).getTime() : Infinity
      const secondDate = b?.startsAt ? new Date(b?.startsAt).getTime() : Infinity
      return firstDate - secondDate
    })[0]
}

export const Overview = () => {
  const { access } = useCurrentSession()
  const { data } = useQuery(EmployeeMyTrainingsIndexPageDocument, {
    variables: { accessId: access.id, next: true },
  })

  const sessions = data?.trainings.trainingsConnection.nodes.flatMap(
    (training) => training.sessions
  )
  const nearestActiveTrainingSession = findNearestActiveTrainingSession(sessions)

  return (
    <Box gap="s40">
      <Box flexDirection="row" gap="s24" justifyContent="flexStart">
        {nearestActiveTrainingSession && (
          <Box width="full" style={{ maxWidth: '50%' }}>
            <NextSessionRow session={nearestActiveTrainingSession} />
          </Box>
        )}
        <Box width="full" style={{ maxWidth: '50%' }}>
          <CompletedTrainings />
        </Box>
      </Box>
      <MyTrainingCardsView />
      <Outlet />
    </Box>
  )
}
